'use strict';

const Container = require('./../../core/container');

module.exports = {
  'events': {
    'menu:more-parameters:ready': [
      {
        'callback': function(items) {
          if (Container.get('isAllowedTo')('USER_RIGHT_FEATURE')) {
            items.push({'name': 'user_group'});
          }

          if (Container.get('isAllowedTo')('MULTILANG_FEATURE') && Container.get('multi-language')) {
            items.push({'name': 'lang_management', 'pos': 7});
          }
        },
      },
    ],
    'menu:user_group:ready': [
      {
        'callback': function(items) {
          items.push({'name': 'user_add', 'pos': 10, 'group': 'user_panel_title'});
          items.push({'name': 'user_management', 'pos': 20});
          items.push({'name': 'group_add', 'pos': 30, 'group': 'group_panel_title'});
          items.push({'name': 'group_management', 'pos': 40});
        },
      },
    ],
    'menu:more-parameters:user_group:click': [
      {'callback': require('./../../services/structure/menu/panel').init.bind(undefined, 'user_group')},
    ],
    'menu:user_group:user_add:click': [
      {
        'callback': () => {
          require('./service/userManagement').createUser();
        },
      },
    ],
    'menu:user_group:user_management:click': [
      {'callback': require('./service/userManagement').list},
    ],
    'menu:user_group:group_add:click': [
      {
        'callback': () => {
          require('./service/groupManagement').createGroup();
        },
      },
    ],
    'menu:user_group:group_management:click': [
      {'callback': require('./service/groupManagement').list},
    ],
    'menu:more-parameters:lang_management:click': [
      {'callback': require('./service/langManagement').onClick},
    ],
    'menu:users:ready': [
      {
        'callback': function(items) {
          items.push({'name': 'user_management'});
        },
      },
    ],
    'menu:my_account:change_password:click': [
      {'callback': require('./service/changePassword').onClick},
    ],
    'flash-callback:lang-finish': [
      {'callback': require('./service/langManagement').onFinish},
    ],
    'flash-callback:update-finish': [
      {'callback': require('./service/account').onUpdateFinish},
    ],
    'menu:my_account:ready': [
      {
        'callback': function(items) {
          items.push({'name': 'translate_bo', 'pos': 10, 'tpl': require('./service/translateBo').init()});
          items.push({'name': 'change_password', 'pos': 20});
          items.push({'name': 'logout', 'pos': 30});
        },
      },
    ],
    'menu:my_account:click': [
      {'callback': require('./service/account').onClick},
    ],
  },
};
